import { FETCH_RRD_INFO, SET_RRD_INFO } from "./actionTypes";

const rrdInfo = {
  overviewData: {},
  deliveryReturnData: {},
  refundsData: {},
};

export const actions = {
  fetchRRDInfo: () => ({
    type: FETCH_RRD_INFO,
  }),
  setRRDInfo: (payload) => ({
    type: SET_RRD_INFO,
    payload,
  }),
};

function reducer(state = rrdInfo, action) {
  switch (action.type) {
    case SET_RRD_INFO: {
      return action.payload;
    }

    default:
      return state;
  }
}

reducer.initialState = rrdInfo;

export default reducer;
